import { findCompanyId } from "../../infrastructure/repository/company-repository";
import { updateTaxRegime } from "../../infrastructure/employees-cache";
import { showErrorMessage } from "../commons/show-error-message";
import { showSuccessMessage } from "../commons/show-success-message";
import { logError, addContextLog } from "../../infrastructure/log";
import { translate } from "../../infrastructure/translate/localization";

export async function changeTaxRegime({ employeeIds, taxRegime }) {
  try {
    const companyId = await findCompanyId();
    await updateTaxRegime({ companyId, employeeIds, taxRegime });

    addContextLog("info", "changeTaxRegime", "request", {
      companyId,
      employeeIds,
      taxRegime,
    });
    showSuccessMessage(
      translate("employees-section.change-tax-regime-success")
    );
  } catch (e) {
    logError(e, `Error to changeTaxRegime with ${taxRegime}`);
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
